import { BlockService } from '@blocksuite/block-std';
import { assertExists } from '@blocksuite/global/utils';
import { DatabaseSelection } from './common/selection.js';
export class DatabaseService extends BlockService {
    mounted() {
        super.mounted();
        this.selectionManager.register(DatabaseSelection);
        this.handleEvent('selectionChange', () => true);
    }
    initDatabaseBlock(page, model, databaseId, viewType, isAppendNewRow = true) {
        const blockModel = page.getBlockById(databaseId);
        assertExists(blockModel);
        blockModel.initTemplate(viewType);
        if (isAppendNewRow) {
            // Add a paragraph after database
            const parent = page.getParent(model);
            assertExists(parent);
            page.addBlock('affine:paragraph', {}, parent.id);
        }
        blockModel.applyColumnUpdate();
    }
}
//# sourceMappingURL=database-service.js.map